import { Hero, FeatureGrid, CarouselImage, SplitFeature, Testimonials } from "@/components/sections"
import { PageMeta } from "@/components/shared/PageMeta"
import { hero, benefits, family, homeProductsCarousel, testimonials } from "@/content/home"
import { PAGE_SEO } from "@/lib/seo"

export default function HomePage(): React.JSX.Element {
	return (
		<>
			<PageMeta {...PAGE_SEO.home} path="/" />
			<Hero
				eyebrow={hero.eyebrow}
				title={hero.title}
				subtitle={hero.subtitle}
				primaryCta={hero.primaryCta}
				secondaryCta={hero.secondaryCta}
			/>

			<FeatureGrid title={benefits.title} items={benefits.items} />
			<SplitFeature title={family.title} body={family.body} backgroundImage={family.backgroundImage} />
			<CarouselImage eyebrow="Productos" items={homeProductsCarousel} />
			<Testimonials title="Nuestros pacientes" items={testimonials} />
		</>
	)
}
